import { modalProcessPlaceChangeStore } from '@/utils/store-accessor'

export class ModalProcessPlaceChangeService {
  public open() {
    modalProcessPlaceChangeStore.open()
  }
}
